import { useId } from 'react';
import Filters from 'src/components/form/filters/filters';
import { searchInputValidationSchema } from 'src/components/form/search/filters-form/helper';
import SearchInput from 'src/components/form/search/filters-form/search-input';
import css from './business-map.module.scss';
import { type BusinessMapParams } from './types';

interface MapFiltersProps {
  onSearch: (filters: BusinessMapParams) => void;
  initialFilters: BusinessMapParams;
}

export default function MapFilters({ onSearch, initialFilters }: Readonly<MapFiltersProps>) {
  const inputId = useId();

  return (
    <Filters
      initialFilters={initialFilters}
      onSearch={onSearch}
      validationSchema={searchInputValidationSchema('search')}
      fieldsToSubmitOnChange={['search']}
      render={({ errors, _, registerAndClearOnChange }) => (
        <div className={css.filtersGroup}>
          <SearchInput
            id={inputId}
            name='search'
            placeholder='Шукати послугу'
            error={errors?.text?.message}
            inputProps={registerAndClearOnChange('search')}
          />
        </div>
      )}
    />
  );
}
